export interface LessonRevisionFields {
  content_revision: number;
  video_revision: number;
  quiz_revision: number;
  coding_revision: number;
}

export type LessonRevisionContext = Partial<LessonRevisionFields>;

export const lessonRevisionContext = (
  lesson: LessonRevisionFields | undefined
): LessonRevisionContext => {
  if (!lesson) return {};
  return {
    content_revision: lesson.content_revision,
    video_revision: lesson.video_revision,
    quiz_revision: lesson.quiz_revision,
    coding_revision: lesson.coding_revision,
  };
};

export const requireLessonRevisionContext = (
  lesson: LessonRevisionFields | undefined
): LessonRevisionFields => {
  if (!lesson) {
    throw new Error("Lesson content is still loading. Try again in a moment.");
  }
  return lessonRevisionContext(lesson) as LessonRevisionFields;
};
